import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { createRole } from "../../api/apiRoles";
import parseError from "../../utils/parseError";

export const useCreateRole = () => {
    const queryClient = useQueryClient();
    const { mutate: createRoleMutate, isPending: isCreating } = useMutation({
        mutationFn: createRole,
        onSuccess: (res) => {
            toast.success(res.message || "Role created");
            queryClient.invalidateQueries(["roles"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to create role"),
    });
    return { createRoleMutate, isCreating };
};
